module.exports = "/lucky-balls/img/infobox/info_Box_031.png";


//////////////////
// WEBPACK FOOTER
// ./src/games/lucky-balls/img/infobox/info_Box_031.png
// module id = 1096
// module chunks = 0